export default __webpack_public_path__ + "static/media/gardeners.e90fd061.png";